import clsx from 'clsx';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'win' | 'loss' | 'warn' | 'info' | 'neutral' | 'live';
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

export function Badge({ children, variant = 'default', size = 'sm', className }: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium rounded-full border tracking-wide',
        {
          'px-1.5 py-0.5 text-[10px]': size === 'xs',
          'px-2 py-0.5 text-xs': size === 'sm',
          'px-3 py-1 text-sm': size === 'md',
        },
        {
          'bg-surface-3 border-surface-4 text-gray-400':
            variant === 'default' || variant === 'neutral',
          'bg-win/20 border-win/30 text-win': variant === 'win',
          'bg-loss/20 border-loss/30 text-loss': variant === 'loss',
          'bg-warn/20 border-warn/30 text-warn': variant === 'warn',
          'bg-info/20 border-info/30 text-info': variant === 'info',
          'bg-win/20 border-win/50 text-win animate-pulse-slow': variant === 'live',
        },
        className,
      )}
    >
      {variant === 'live' && (
        <span className="w-1.5 h-1.5 rounded-full bg-win mr-1.5 animate-pulse" />
      )}
      {children}
    </span>
  );
}
